import { CostOptimization } from "@web-app/types";

import { formatCurrency, formatOptimizationDate } from "../utils";

import StatusBadge from "./StatusBadge";

type OptimizationsListProps = {
  onSelect?: (optimization: CostOptimization) => void;
  optimizations: CostOptimization[];
};

const Stat = ({ label, value }: { label: string; value: string }) => (
  <span className="text-sm text-gray-600">
    {label} <span className="font-medium text-gray-900">{value}</span>
  </span>
);

export default function OptimizationsList({
  optimizations,
  onSelect,
}: OptimizationsListProps) {
  return (
    <div>
      <h3 className="text-base font-semibold text-gray-900">Optimizations</h3>

      {optimizations.length === 0 ? (
        <p className="mt-4 text-sm text-gray-500">
          No optimizations yet. Start a new one to compare provider costs.
        </p>
      ) : (
        <div className="mt-4 space-y-3">
          {optimizations.map((optimization) => (
            <button
              key={optimization.id}
              type="button"
              onClick={() => onSelect?.(optimization)}
              className="flex w-full flex-wrap items-center justify-between gap-4 rounded-lg border border-gray-200 p-4 text-left hover:border-gray-400"
            >
              <div className="flex items-center gap-2">
                <span className="font-semibold text-gray-900">
                  {optimization.name}
                </span>
                <StatusBadge status={optimization.status} />
              </div>
              <div className="flex flex-wrap items-center gap-x-6 gap-y-1">
                <Stat
                  label="Avg. CPD:"
                  value={`(${formatCurrency(
                    optimization.avgCostPerDrop,
                    optimization.currency || "USD",
                  )})`}
                />
                <Stat
                  label="Total Cost:"
                  value={formatCurrency(
                    optimization.totalCost,
                    optimization.currency || "USD",
                  )}
                />
                <Stat
                  label="Total Orders:"
                  value={String(optimization.totalOrders)}
                />
                <Stat
                  label="Assigned #DSP:"
                  value={String(optimization.dspCount)}
                />
                <span className="text-sm text-gray-500">
                  Created- {formatOptimizationDate(optimization.createdAt)}
                </span>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
